import React, { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const links = [
  { href: "#services", label: "Services" },
  { href: "#gallery", label: "Projects" },
  { href: "#about", label: "About" },
  { href: "#testimonials", label: "Reviews" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const { site } = useSite();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 bg-white border-b border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a
            data-testid="nav-logo"
            href="#top"
            className="flex items-center gap-3"
          >
            {site?.logo_url && (
              <img
                src={site.logo_url}
                alt={site?.business_name || "J&S Complete Remodeling Inc"}
                className="h-14 w-auto"
              />
            )}
            <span className="hidden sm:block font-heading font-bold text-lg uppercase tracking-tight leading-none">
              {site?.business_name?.split(" ").slice(0, 2).join(" ") || "J&S Complete"}
              <span className="block text-[10px] tracking-[0.25em] text-neutral-500 font-medium mt-1">
                REMODELING INC
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <a
                key={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                href={l.href}
                className="font-heading text-sm uppercase tracking-widest text-neutral-800 hover:text-[#DC2626] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              data-testid="nav-phone-link"
              href={`tel:${site?.phone_raw || "+12249669352"}`}
              className="btn-primary-cta"
            >
              <Phone size={16} strokeWidth={2.5} />
              {site?.phone || "(224) 966-9352"}
            </a>
          </div>

          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-6 border-t border-neutral-200 pt-4 space-y-3">
            {links.map((l) => (
              <a
                key={l.href}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                href={l.href}
                onClick={() => setOpen(false)}
                className="block font-heading text-base uppercase tracking-widest text-neutral-900 py-2"
              >
                {l.label}
              </a>
            ))}
            <a
              data-testid="mobile-nav-phone"
              href={`tel:${site?.phone_raw || "+12249669352"}`}
              className="btn-primary-cta w-full justify-center mt-3"
            >
              <Phone size={16} /> {site?.phone || "(224) 966-9352"}
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
